import axios from 'axios';
import { store } from '@/redux/store';
import { logout } from '@/redux/slices/authSlice';

const api = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL ?? ''}/api`,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = store.getState().auth.token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Pages a signed-out visitor is entitled to sit on. A dead token left in
// localStorage still 401s the /me call on boot, and before this list that bounced
// people straight off the public landing page to the login form.
const PUBLIC_PATHS = new Set(['/', '/login', '/forgot-password']);
const isPublicPath = (path) => PUBLIC_PATHS.has(path) || path.startsWith('/reset-password/');

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      // The credentials are dead either way, so drop them — that alone flips the
      // landing page's button back from "Dashboard" to "Sign in".
      store.dispatch(logout());
      if (!isPublicPath(window.location.pathname)) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
